import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LANGUAGES = {
  en: { name: "English", nativeName: "English", flag: "🇬🇧", uiComplete: true },
  hi: { name: "Hindi", nativeName: "हिंदी", flag: "🇮🇳", uiComplete: true },
  ta: { name: "Tamil", nativeName: "தமிழ்", flag: "🇮🇳", uiComplete: true },
  te: { name: "Telugu", nativeName: "తెలుగు", flag: "🇮🇳", uiComplete: true },
  bn: { name: "Bengali", nativeName: "বাংলা", flag: "🇮🇳", uiComplete: true },
  mr: { name: "Marathi", nativeName: "मराठी", flag: "🇮🇳", uiComplete: true },
  gu: { name: "Gujarati", nativeName: "ગુજરાતી", flag: "🇮🇳", uiComplete: true },
  kn: { name: "Kannada", nativeName: "ಕನ್ನಡ", flag: "🇮🇳", uiComplete: true },
  ml: { name: "Malayalam", nativeName: "മലയാളം", flag: "🇮🇳", uiComplete: true },
  pa: { name: "Punjabi", nativeName: "ਪੰਜਾਬੀ", flag: "🇮🇳", uiComplete: true },
};

const TRANSLATIONS = {
  en: {
    home: "Home", about: "About", bodyMap: "Body Map",
    uploadLabReport: "Upload lab report", uploadMedicine: "Upload medicine",
    skinDetector: "Skin detector", contactUs: "Contact us",
    findNearbyHospital: "Find nearby hospital",
    homeTitle: "Get best quality health care services at reasonable cost",
    homeSubtitle: "Healthcare AI Assistant is your digital front door for everyday health questions.",
    startHealthChat: "Start health chat", symptomChatGuidance: "Symptom chat & guidance",
    labMedicineUploads: "Lab & medicine uploads", hospitalsNearYou: "Hospitals near you",
    chatTitle: "Healthcare AI Assistant",
    chatSubtitle: "Chat about symptoms here. For lab reports or medicine photos, use the menu above.",
    typeMessage: "Describe symptoms or ask a question...", send: "Send", speak: "Speak", readAloud: "Read aloud",
    bodyMapTitle: "Body Map Symptom Checker",
    bodyMapSubtitle: "Click on body parts to select symptoms, adjust intensity, and get AI-powered health insights.",
    selectAffectedArea: "Select Affected Area", clickBodyParts: "Click on body parts to see related symptoms",
    generalSymptoms: "General Symptoms:", symptomsSelected: "symptoms selected", symptomSelected: "symptom selected",
    intensity: "Intensity:", mild: "mild", moderate: "moderate", severe: "severe",
    reset: "Reset", analyzeSymptoms: "Analyze Symptoms", analyzing: "Analyzing...",
    analysisResult: "Analysis Result", continueInChat: "Continue in Chat",
    selectAtLeastOne: "Please select at least one symptom",
    uploadMedicineTitle: "Upload medicine photo",
    uploadMedicineSubtitle: "Take or upload a clear photo of the packaging or label.",
    uploadLabReportTitle: "Upload lab report",
    uploadLabReportSubtitle: "Upload blood test reports and get easy-to-understand summaries.",
    skinDetectorTitle: "Skin Disease Detector",
    skinDetectorSubtitle: "Upload a clear photo of the affected skin area for AI analysis.",
    dropImageHere: "Drop an image here, or click to browse",
    uploadAndIdentify: "Upload & identify", analyzeSkin: "Analyze Skin", result: "Result",
    backToHome: "Back to Home", loading: "Loading...", serverError: "Server error occurred.", noFileSelected: "No file selected.",
    featuresTitle: "Everything you need for better health",
    bodyMapFeature: "Click on body parts to select symptoms visually. Adjust intensity and get instant AI diagnosis.",
    chatFeature: "Describe symptoms in plain language and get instant health guidance with precautions.",
    skinFeature: "Upload photos of rashes, acne, or skin conditions for AI-powered analysis and care tips.",
    labFeature: "Upload blood test reports and get easy-to-understand summaries with health insights.",
    medicineFeature: "Take a photo of medicine packaging to identify it and learn about uses and side effects.",
    hospitalFeature: "Locate hospitals near you with ratings, phone numbers, and directions.",
    tryItNow: "Try it now", new: "NEW",
  },

  hi: {
    home: "होम", about: "हमारे बारे में", bodyMap: "बॉडी मैप",
    uploadLabReport: "लैब रिपोर्ट अपलोड करें", uploadMedicine: "दवा अपलोड करें",
    skinDetector: "त्वचा जांच", contactUs: "संपर्क करें",
    findNearbyHospital: "नजदीकी अस्पताल खोजें",
    homeTitle: "उचित मूल्य पर सर्वोत्तम स्वास्थ्य सेवाएं प्राप्त करें",
    homeSubtitle: "हेल्थकेयर एआई असिस्टेंट आपके रोजमर्रा के स्वास्थ्य प्रश्नों के लिए डिजिटल दरवाजा है।",
    startHealthChat: "स्वास्थ्य चैट शुरू करें", symptomChatGuidance: "लक्षण चैट और मार्गदर्शन",
    labMedicineUploads: "लैब और दवा अपलोड", hospitalsNearYou: "आपके पास अस्पताल",
    chatTitle: "हेल्थकेयर एआई असिस्टेंट",
    chatSubtitle: "यहां लक्षणों के बारे में चैट करें। लैब रिपोर्ट के लिए ऊपर मेनू का उपयोग करें।",
    typeMessage: "लक्षण बताएं या प्रश्न पूछें...", send: "भेजें", speak: "बोलें", readAloud: "जोर से पढ़ें",
    bodyMapTitle: "बॉडी मैप लक्षण जांच",
    bodyMapSubtitle: "शरीर के अंगों पर क्लिक करें, लक्षण चुनें और एआई स्वास्थ्य जानकारी प्राप्त करें।",
    selectAffectedArea: "प्रभावित क्षेत्र चुनें", clickBodyParts: "संबंधित लक्षण देखने के लिए क्लिक करें",
    generalSymptoms: "सामान्य लक्षण:", symptomsSelected: "लक्षण चुने गए", symptomSelected: "लक्षण चुना गया",
    intensity: "तीव्रता:", mild: "हल्का", moderate: "मध्यम", severe: "गंभीर",
    reset: "रीसेट", analyzeSymptoms: "लक्षणों का विश्लेषण करें", analyzing: "विश्लेषण हो रहा है...",
    analysisResult: "विश्लेषण परिणाम", continueInChat: "चैट में जारी रखें",
    selectAtLeastOne: "कृपया कम से कम एक लक्षण चुनें",
    uploadMedicineTitle: "दवा की तस्वीर अपलोड करें",
    uploadMedicineSubtitle: "पैकेजिंग या लेबल की स्पष्ट तस्वीर लें या अपलोड करें।",
    uploadLabReportTitle: "लैब रिपोर्ट अपलोड करें",
    uploadLabReportSubtitle: "रक्त परीक्षण रिपोर्ट अपलोड करें और आसान सारांश प्राप्त करें।",
    skinDetectorTitle: "त्वचा रोग डिटेक्टर",
    skinDetectorSubtitle: "प्रभावित त्वचा की तस्वीर अपलोड करें और एआई सुझाव प्राप्त करें।",
    dropImageHere: "यहां छवि छोड़ें, या ब्राउज़ करने के लिए क्लिक करें",
    uploadAndIdentify: "अपलोड करें और पहचानें", analyzeSkin: "त्वचा का विश्लेषण करें", result: "परिणाम",
    backToHome: "होम पर वापस जाएं", loading: "लोड हो रहा है...", serverError: "सर्वर त्रुटि हुई।", noFileSelected: "कोई फ़ाइल चयनित नहीं।",
    featuresTitle: "बेहतर स्वास्थ्य के लिए सब कुछ",
    bodyMapFeature: "दृश्य रूप से लक्षण चुनने के लिए शरीर के अंगों पर क्लिक करें।",
    chatFeature: "सरल भाषा में लक्षणों का वर्णन करें और तत्काल स्वास्थ्य मार्गदर्शन प्राप्त करें।",
    skinFeature: "एआई विश्लेषण के लिए चकत्ते या त्वचा की स्थिति की तस्वीरें अपलोड करें।",
    labFeature: "रक्त परीक्षण रिपोर्ट अपलोड करें और आसान सारांश प्राप्त करें।",
    medicineFeature: "दवा की पैकेजिंग की तस्वीर लें और उपयोग के बारे में जानें।",
    hospitalFeature: "रेटिंग और दिशाओं के साथ अपने पास के अस्पतालों का पता लगाएं।",
    tryItNow: "अभी आज़माएं", new: "नया",
  },

  ta: {
    home: "முகப்பு", about: "எங்களை பற்றி", bodyMap: "உடல் வரைபடம்",
    uploadLabReport: "ஆய்வக அறிக்கையை பதிவேற்றவும்", uploadMedicine: "மருந்தை பதிவேற்றவும்",
    skinDetector: "தோல் கண்டறிதல்", contactUs: "எங்களை தொடர்பு கொள்ளவும்",
    findNearbyHospital: "அருகிலுள்ள மருத்துவமனையைக் கண்டறியவும்",
    homeTitle: "நியாயமான விலையில் சிறந்த சுகாதார சேவைகளைப் பெறுங்கள்",
    homeSubtitle: "ஹெல்த்கேர் AI உதவியாளர் உங்கள் அன்றாட சுகாதார கேள்விகளுக்கான டிஜிட்டல் கதவு.",
    startHealthChat: "சுகாதார அரட்டையைத் தொடங்கவும்", symptomChatGuidance: "அறிகுறி அரட்டை மற்றும் வழிகாட்டுதல்",
    labMedicineUploads: "ஆய்வகம் மற்றும் மருந்து பதிவேற்றங்கள்", hospitalsNearYou: "அருகில் உள்ள மருத்துவமனைகள்",
    chatTitle: "ஹெல்த்கேர் AI உதவியாளர்",
    chatSubtitle: "இங்கே அறிகுறிகளைப் பற்றி அரட்டையடிக்கவும். ஆய்வக அறிக்கைகளுக்கு மேலே உள்ள மெனுவைப் பயன்படுத்தவும்.",
    typeMessage: "அறிகுறிகளை விவரிக்கவும் அல்லது கேள்வி கேளுங்கள்...", send: "அனுப்பு", speak: "பேசு", readAloud: "சத்தமாக படிக்கவும்",
    bodyMapTitle: "உடல் வரைபடம் அறிகுறி சரிபார்ப்பு",
    bodyMapSubtitle: "உடல் பாகங்களைக் கிளிக் செய்து அறிகுறிகளைத் தேர்ந்தெடுக்கவும் மற்றும் AI நுண்ணறிவுகளைப் பெறவும்.",
    selectAffectedArea: "பாதிக்கப்பட்ட பகுதியைத் தேர்ந்தெடுக்கவும்", clickBodyParts: "தொடர்புடைய அறிகுறிகளைக் காண கிளிக் செய்யவும்",
    generalSymptoms: "பொதுவான அறிகுறிகள்:", symptomsSelected: "அறிகுறிகள் தேர்ந்தெடுக்கப்பட்டன", symptomSelected: "அறிகுறி தேர்ந்தெடுக்கப்பட்டது",
    intensity: "தீவிரம்:", mild: "லேசான", moderate: "மிதமான", severe: "கடுமையான",
    reset: "மீட்டமை", analyzeSymptoms: "அறிகுறிகளை பகுப்பாய்வு செய்யவும்", analyzing: "பகுப்பாய்வு செய்கிறது...",
    analysisResult: "பகுப்பாய்வு முடிவு", continueInChat: "அரட்டையில் தொடரவும்",
    selectAtLeastOne: "தயவுசெய்து குறைந்தது ஒரு அறிகுறியையாவது தேர்ந்தெடுக்கவும்",
    uploadMedicineTitle: "மருந்து புகைப்படத்தை பதிவேற்றவும்",
    uploadMedicineSubtitle: "பேக்கேஜிங் அல்லது லேபிளின் தெளிவான புகைப்படத்தை பதிவேற்றவும்.",
    uploadLabReportTitle: "ஆய்வக அறிக்கையை பதிவேற்றவும்",
    uploadLabReportSubtitle: "இரத்த பரிசோதனை அறிக்கைகளை பதிவேற்றவும் மற்றும் எளிதான சுருக்கங்களைப் பெறவும்.",
    skinDetectorTitle: "தோல் நோய் கண்டறிதல்",
    skinDetectorSubtitle: "பாதிக்கப்பட்ட தோல் பகுதியின் புகைப்படத்தை பதிவேற்றவும் மற்றும் AI பரிந்துரைகளைப் பெறவும்.",
    dropImageHere: "இங்கே ஒரு படத்தை விடவும், அல்லது உலாவ கிளிக் செய்யவும்",
    uploadAndIdentify: "பதிவேற்றவும் மற்றும் அடையாளம் காணவும்", analyzeSkin: "தோலை பகுப்பாய்வு செய்யவும்", result: "முடிவு",
    backToHome: "முகப்புக்குத் திரும்பு", loading: "ஏற்றுகிறது...", serverError: "சர்வர் பிழை ஏற்பட்டது.", noFileSelected: "எந்த கோப்பும் தேர்ந்தெடுக்கப்படவில்லை.",
    featuresTitle: "சிறந்த சுகாதாரத்திற்கு நீங்கள் தேவையான அனைத்தும்",
    bodyMapFeature: "காட்சி ரீதியாக அறிகுறிகளைத் தேர்ந்தெடுக்க உடல் பாகங்களைக் கிளிக் செய்யவும்.",
    chatFeature: "எளிய மொழியில் அறிகுறிகளை விவரிக்கவும் மற்றும் உடனடி வழிகாட்டுதலைப் பெறவும்.",
    skinFeature: "AI பகுப்பாய்வுக்கு சொறி அல்லது தோல் நிலைகளின் புகைப்படங்களை பதிவேற்றவும்.",
    labFeature: "இரத்த பரிசோதனை அறிக்கைகளை பதிவேற்றவும் மற்றும் எளிதான சுருக்கங்களைப் பெறவும்.",
    medicineFeature: "மருந்து பேக்கேஜிங்கின் புகைப்படத்தை எடுக்கவும் மற்றும் பயன்பாடுகளைப் பற்றி அறியவும்.",
    hospitalFeature: "மதிப்பீடுகள் மற்றும் திசைகளுடன் அருகில் உள்ள மருத்துவமனைகளைக் கண்டறியவும்.",
    tryItNow: "இப்போது முயற்சிக்கவும்", new: "புதிய",
  },

  te: {
    home: "హోమ్", about: "మా గురించి", bodyMap: "బాడీ మ్యాప్",
    uploadLabReport: "లాబ్ రిపోర్ట్ అప్‌లోడ్ చేయండి", uploadMedicine: "మందు అప్‌లోడ్ చేయండి",
    skinDetector: "చర్మ పరీక్ష", contactUs: "మమ్మల్ని సంప్రదించండి",
    findNearbyHospital: "సమీప ఆసుపత్రిని కనుగొనండి",
    homeTitle: "సహేతుకమైన ధరలో అత్యుత్తమ ఆరోగ్య సేవలు పొందండి",
    homeSubtitle: "హెల్త్‌కేర్ AI అసిస్టెంట్ మీ రోజువారీ ఆరోగ్య ప్రశ్నలకు డిజిటల్ ద్వారం.",
    startHealthChat: "ఆరోగ్య చాట్ ప్రారంభించండి", symptomChatGuidance: "లక్షణ చాట్ మరియు మార్గదర్శకత",
    labMedicineUploads: "లాబ్ మరియు మందు అప్‌లోడ్‌లు", hospitalsNearYou: "మీ సమీపంలో ఆసుపత్రులు",
    chatTitle: "హెల్త్‌కేర్ AI అసిస్టెంట్",
    chatSubtitle: "ఇక్కడ లక్షణాల గురించి చాట్ చేయండి. లాబ్ రిపోర్ట్‌ల కోసం పై మెనూని ఉపయోగించండి.",
    typeMessage: "లక్షణాలు వివరించండి లేదా ప్రశ్న అడగండి...", send: "పంపండి", speak: "మాట్లాడండి", readAloud: "బిగ్గరగా చదవండి",
    bodyMapTitle: "బాడీ మ్యాప్ లక్షణ పరీక్షకు",
    bodyMapSubtitle: "శరీర భాగాలపై క్లిక్ చేసి లక్షణాలు ఎంచుకోండి మరియు AI ఆరోగ్య అంతర్దృష్టులు పొందండి.",
    selectAffectedArea: "ప్రభావిత ప్రాంతాన్ని ఎంచుకోండి", clickBodyParts: "సంబంధిత లక్షణాలు చూడటానికి క్లిక్ చేయండి",
    generalSymptoms: "సాధారణ లక్షణాలు:", symptomsSelected: "లక్షణాలు ఎంచుకోబడ్డాయి", symptomSelected: "లక్షణం ఎంచుకోబడింది",
    intensity: "తీవ్రత:", mild: "తేలికపాటి", moderate: "మధ్యస్థ", severe: "తీవ్రమైన",
    reset: "రీసెట్", analyzeSymptoms: "లక్షణాలు విశ్లేషించండి", analyzing: "విశ్లేషిస్తోంది...",
    analysisResult: "విశ్లేషణ ఫలితం", continueInChat: "చాట్‌లో కొనసాగించండి",
    selectAtLeastOne: "దయచేసి కనీసం ఒక లక్షణం ఎంచుకోండి",
    uploadMedicineTitle: "మందు ఫోటో అప్‌లోడ్ చేయండి",
    uploadMedicineSubtitle: "ప్యాకేజింగ్ లేదా లేబుల్ యొక్క స్పష్టమైన ఫోటో తీయండి లేదా అప్‌లోడ్ చేయండి.",
    uploadLabReportTitle: "లాబ్ రిపోర్ట్ అప్‌లోడ్ చేయండి",
    uploadLabReportSubtitle: "రక్త పరీక్ష నివేదికలు అప్‌లోడ్ చేసి సులభంగా అర్థమయ్యే సారాంశాలు పొందండి.",
    skinDetectorTitle: "చర్మ వ్యాధి డిటెక్టర్",
    skinDetectorSubtitle: "ప్రభావిత చర్మ ప్రాంతం యొక్క ఫోటో అప్‌లోడ్ చేసి AI సూచనలు పొందండి.",
    dropImageHere: "ఇక్కడ చిత్రాన్ని వదలండి, లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి",
    uploadAndIdentify: "అప్‌లోడ్ చేసి గుర్తించండి", analyzeSkin: "చర్మాన్ని విశ్లేషించండి", result: "ఫలితం",
    backToHome: "హోమ్‌కు తిరిగి వెళ్ళండి", loading: "లోడ్ అవుతోంది...", serverError: "సర్వర్ లోపం సంభవించింది.", noFileSelected: "ఫైల్ ఏదీ ఎంచుకోబడలేదు.",
    featuresTitle: "మెరుగైన ఆరోగ్యానికి మీకు అవసరమైన అన్నీ",
    bodyMapFeature: "దృశ్యమానంగా లక్షణాలు ఎంచుకోవడానికి శరీర భాగాలపై క్లిక్ చేయండి.",
    chatFeature: "సాధారణ భాషలో లక్షణాలు వివరించి తక్షణ ఆరోగ్య మార్గదర్శకత పొందండి.",
    skinFeature: "AI విశ్లేషణ కోసం దద్దుర్లు లేదా చర్మ పరిస్థితుల ఫోటోలు అప్‌లోడ్ చేయండి.",
    labFeature: "రక్త పరీక్ష నివేదికలు అప్‌లోడ్ చేసి సులభంగా అర్థమయ్యే సారాంశాలు పొందండి.",
    medicineFeature: "మందు ప్యాకేజింగ్ ఫోటో తీసి దాన్ని గుర్తించి ఉపయోగాల గురించి తెలుసుకోండి.",
    hospitalFeature: "రేటింగ్‌లు మరియు దిశలతో సమీప ఆసుపత్రులను కనుగొనండి.",
    tryItNow: "ఇప్పుడే ప్రయత్నించండి", new: "కొత్త",
  },

  bn: {
    home: "হোম", about: "আমাদের সম্পর্কে", bodyMap: "বডি ম্যাপ",
    uploadLabReport: "ল্যাব রিপোর্ট আপলোড করুন", uploadMedicine: "ওষুধ আপলোড করুন",
    skinDetector: "ত্বক পরীক্ষা", contactUs: "যোগাযোগ করুন",
    findNearbyHospital: "কাছের হাসপাতাল খুঁজুন",
    homeTitle: "সাশ্রয়ী মূল্যে সর্বোত্তম স্বাস্থ্যসেবা পান",
    homeSubtitle: "হেলথকেয়ার AI সহকারী আপনার দৈনন্দিন স্বাস্থ্য প্রশ্নের জন্য ডিজিটাল দরজা।",
    startHealthChat: "স্বাস্থ্য চ্যাট শুরু করুন", symptomChatGuidance: "লক্ষণ চ্যাট ও নির্দেশনা",
    labMedicineUploads: "ল্যাব ও ওষুধ আপলোড", hospitalsNearYou: "আপনার কাছের হাসপাতাল",
    chatTitle: "হেলথকেয়ার AI সহকারী",
    chatSubtitle: "এখানে লক্ষণ সম্পর্কে চ্যাট করুন। ল্যাব রিপোর্টের জন্য উপরের মেনু ব্যবহার করুন।",
    typeMessage: "লক্ষণ বর্ণনা করুন বা প্রশ্ন করুন...", send: "পাঠান", speak: "বলুন", readAloud: "জোরে পড়ুন",
    bodyMapTitle: "বডি ম্যাপ লক্ষণ পরীক্ষক",
    bodyMapSubtitle: "শরীরের অংশে ক্লিক করুন, লক্ষণ বেছে নিন এবং AI স্বাস্থ্য অন্তর্দৃষ্টি পান।",
    selectAffectedArea: "আক্রান্ত এলাকা বেছে নিন", clickBodyParts: "সম্পর্কিত লক্ষণ দেখতে ক্লিক করুন",
    generalSymptoms: "সাধারণ লক্ষণ:", symptomsSelected: "লক্ষণ নির্বাচিত হয়েছে", symptomSelected: "লক্ষণ নির্বাচিত হয়েছে",
    intensity: "তীব্রতা:", mild: "হালকা", moderate: "মাঝারি", severe: "গুরুতর",
    reset: "রিসেট", analyzeSymptoms: "লক্ষণ বিশ্লেষণ করুন", analyzing: "বিশ্লেষণ হচ্ছে...",
    analysisResult: "বিশ্লেষণ ফলাফল", continueInChat: "চ্যাটে চালিয়ে যান",
    selectAtLeastOne: "অনুগ্রহ করে কমপক্ষে একটি লক্ষণ বেছে নিন",
    uploadMedicineTitle: "ওষুধের ছবি আপলোড করুন",
    uploadMedicineSubtitle: "প্যাকেজিং বা লেবেলের স্পষ্ট ছবি তুলুন বা আপলোড করুন।",
    uploadLabReportTitle: "ল্যাব রিপোর্ট আপলোড করুন",
    uploadLabReportSubtitle: "রক্ত পরীক্ষার রিপোর্ট আপলোড করুন এবং সহজবোধ্য সারসংক্ষেপ পান।",
    skinDetectorTitle: "ত্বক রোগ ডিটেক্টর",
    skinDetectorSubtitle: "আক্রান্ত ত্বকের স্পষ্ট ছবি আপলোড করুন এবং AI পরামর্শ পান।",
    dropImageHere: "এখানে ছবি ফেলুন, বা ব্রাউজ করতে ক্লিক করুন",
    uploadAndIdentify: "আপলোড করুন ও সনাক্ত করুন", analyzeSkin: "ত্বক বিশ্লেষণ করুন", result: "ফলাফল",
    backToHome: "হোমে ফিরে যান", loading: "লোড হচ্ছে...", serverError: "সার্ভার ত্রুটি হয়েছে।", noFileSelected: "কোনো ফাইল নির্বাচিত হয়নি।",
    featuresTitle: "সুস্বাস্থ্যের জন্য আপনার প্রয়োজনীয় সব কিছু",
    bodyMapFeature: "দৃশ্যমানভাবে লক্ষণ বেছে নিতে শরীরের অংশে ক্লিক করুন।",
    chatFeature: "সহজ ভাষায় লক্ষণ বর্ণনা করুন এবং তাৎক্ষণিক স্বাস্থ্য নির্দেশনা পান।",
    skinFeature: "AI বিশ্লেষণের জন্য ফুসকুড়ি বা ত্বকের অবস্থার ছবি আপলোড করুন।",
    labFeature: "রক্ত পরীক্ষার রিপোর্ট আপলোড করুন এবং সহজবোধ্য সারসংক্ষেপ পান।",
    medicineFeature: "ওষুধের প্যাকেজিংয়ের ছবি তুলুন এবং ব্যবহার সম্পর্কে জানুন।",
    hospitalFeature: "রেটিং ও দিকনির্দেশনা সহ কাছের হাসপাতাল খুঁজুন।",
    tryItNow: "এখনই চেষ্টা করুন", new: "নতুন",
  },

  mr: {
    home: "मुख्यपृष्ठ", about: "आमच्याबद्दल", bodyMap: "बॉडी मॅप",
    uploadLabReport: "लॅब रिपोर्ट अपलोड करा", uploadMedicine: "औषध अपलोड करा",
    skinDetector: "त्वचा तपासणी", contactUs: "आमच्याशी संपर्क करा",
    findNearbyHospital: "जवळचे रुग्णालय शोधा",
    homeTitle: "वाजवी किमतीत सर्वोत्तम आरोग्य सेवा मिळवा",
    homeSubtitle: "हेल्थकेअर AI सहाय्यक हे तुमच्या दैनंदिन आरोग्य प्रश्नांसाठी डिजिटल दरवाजा आहे।",
    startHealthChat: "आरोग्य चॅट सुरू करा", symptomChatGuidance: "लक्षण चॅट आणि मार्गदर्शन",
    labMedicineUploads: "लॅब आणि औषध अपलोड", hospitalsNearYou: "तुमच्या जवळची रुग्णालये",
    chatTitle: "हेल्थकेअर AI सहाय्यक",
    chatSubtitle: "येथे लक्षणांबद्दल चॅट करा। लॅब रिपोर्टसाठी वरील मेनू वापरा।",
    typeMessage: "लक्षणे सांगा किंवा प्रश्न विचारा...", send: "पाठवा", speak: "बोला", readAloud: "मोठ्याने वाचा",
    bodyMapTitle: "बॉडी मॅप लक्षण तपासणी",
    bodyMapSubtitle: "शरीराच्या भागांवर क्लिक करा, लक्षणे निवडा आणि AI आरोग्य माहिती मिळवा।",
    selectAffectedArea: "प्रभावित क्षेत्र निवडा", clickBodyParts: "संबंधित लक्षणे पाहण्यासाठी क्लिक करा",
    generalSymptoms: "सामान्य लक्षणे:", symptomsSelected: "लक्षणे निवडली", symptomSelected: "लक्षण निवडले",
    intensity: "तीव्रता:", mild: "सौम्य", moderate: "मध्यम", severe: "तीव्र",
    reset: "रीसेट", analyzeSymptoms: "लक्षणांचे विश्लेषण करा", analyzing: "विश्लेषण होत आहे...",
    analysisResult: "विश्लेषण निकाल", continueInChat: "चॅटमध्ये सुरू ठेवा",
    selectAtLeastOne: "कृपया किमान एक लक्षण निवडा",
    uploadMedicineTitle: "औषधाचा फोटो अपलोड करा",
    uploadMedicineSubtitle: "पॅकेजिंग किंवा लेबलचा स्पष्ट फोटो काढा किंवा अपलोड करा।",
    uploadLabReportTitle: "लॅब रिपोर्ट अपलोड करा",
    uploadLabReportSubtitle: "रक्त चाचणी अहवाल अपलोड करा आणि सोप्या भाषेत सारांश मिळवा।",
    skinDetectorTitle: "त्वचा रोग डिटेक्टर",
    skinDetectorSubtitle: "प्रभावित त्वचेचा फोटो अपलोड करा आणि AI सूचना मिळवा।",
    dropImageHere: "येथे प्रतिमा टाका, किंवा ब्राउझ करण्यासाठी क्लिक करा",
    uploadAndIdentify: "अपलोड करा आणि ओळखा", analyzeSkin: "त्वचेचे विश्लेषण करा", result: "निकाल",
    backToHome: "मुख्यपृष्ठावर परत जा", loading: "लोड होत आहे...", serverError: "सर्व्हर त्रुटी आली।", noFileSelected: "कोणतीही फाइल निवडली नाही।",
    featuresTitle: "चांगल्या आरोग्यासाठी तुम्हाला हवे ते सर्व",
    bodyMapFeature: "दृश्यरित्या लक्षणे निवडण्यासाठी शरीराच्या भागांवर क्लिक करा।",
    chatFeature: "सोप्या भाषेत लक्षणे सांगा आणि त्वरित आरोग्य मार्गदर्शन मिळवा।",
    skinFeature: "AI विश्लेषणासाठी पुरळ किंवा त्वचेच्या स्थितीचे फोटो अपलोड करा।",
    labFeature: "रक्त चाचणी अहवाल अपलोड करा आणि सोप्या भाषेत सारांश मिळवा।",
    medicineFeature: "औषधाच्या पॅकेजिंगचा फोटो काढा आणि वापराबद्दल जाणून घ्या।",
    hospitalFeature: "रेटिंग आणि दिशांसह जवळची रुग्णालये शोधा।",
    tryItNow: "आत्ता वापरून पहा", new: "नवीन",
  },

  gu: {
    home: "હોમ", about: "અમારા વિશે", bodyMap: "બોડી મેપ",
    uploadLabReport: "લેબ રિપોર્ટ અપલોડ કરો", uploadMedicine: "દવા અપલોડ કરો",
    skinDetector: "ત્વચા તપાસ", contactUs: "અમારો સંપર્ક કરો",
    findNearbyHospital: "નજીકની હોસ્પિટલ શોધો",
    homeTitle: "વ્યાજબી કિંમતે શ્રેષ્ઠ આરોગ્ય સેવાઓ મેળવો",
    homeSubtitle: "હેલ્થકેર AI સહાયક તમારા રોજિંદા આરોગ્ય પ્રશ્નો માટે ડિજિટલ દ્વાર છે।",
    startHealthChat: "આરોગ્ય ચેટ શરૂ કરો", symptomChatGuidance: "લક્ષણ ચેટ અને માર્ગદર્શન",
    labMedicineUploads: "લેબ અને દવા અપલોડ", hospitalsNearYou: "તમારી નજીકની હોસ્પિટલો",
    chatTitle: "હેલ્થકેર AI સહાયક",
    chatSubtitle: "અહીં લક્ષણો વિશે ચેટ કરો। લેબ રિપોર્ટ માટે ઉપરના મેનૂનો ઉપયોગ કરો।",
    typeMessage: "લક્ષણો જણાવો અથવા પ્રશ્ન પૂછો...", send: "મોકલો", speak: "બોલો", readAloud: "મોટેથી વાંચો",
    bodyMapTitle: "બોડી મેપ લક્ષણ તપાસ",
    bodyMapSubtitle: "શરીરના ભાગો પર ક્લિક કરો, લક્ષણો પસંદ કરો અને AI આરોગ્ય માહિતી મેળવો।",
    selectAffectedArea: "અસરગ્રસ્ત વિસ્તાર પસંદ કરો", clickBodyParts: "સંબંધિત લક્ષણો જોવા ક્લિક કરો",
    generalSymptoms: "સામાન્ય લક્ષણો:", symptomsSelected: "લક્ષણો પસંદ થયા", symptomSelected: "લક્ષણ પસંદ થયું",
    intensity: "તીવ્રતા:", mild: "હળવી", moderate: "મધ્યમ", severe: "ગંભીર",
    reset: "રીસેટ", analyzeSymptoms: "લક્ષણોનું વિશ્લેષણ કરો", analyzing: "વિશ્લેષણ થઈ રહ્યું છે...",
    analysisResult: "વિશ્લેષણ પરિણામ", continueInChat: "ચેટમાં ચાલુ રાખો",
    selectAtLeastOne: "કૃપા કરીને ઓછામાં ઓછું એક લક્ષણ પસંદ કરો",
    uploadMedicineTitle: "દવાનો ફોટો અપલોડ કરો",
    uploadMedicineSubtitle: "પેકેજિંગ અથવા લેબલનો સ્પષ્ટ ફોટો લો અથવા અપલોડ કરો।",
    uploadLabReportTitle: "લેબ રિપોર્ટ અપલોડ કરો",
    uploadLabReportSubtitle: "રક્ત પરીક્ષણ અહેવાલ અપલોડ કરો અને સરળ સારાંશ મેળવો।",
    skinDetectorTitle: "ત્વચા રોગ ડિટેક્ટર",
    skinDetectorSubtitle: "અસરગ્રસ્ત ત્વચાનો ફોટો અપલોડ કરો અને AI સૂચનો મેળવો।",
    dropImageHere: "અહીં છબી મૂકો, અથવા બ્રાઉઝ કરવા ક્લિક કરો",
    uploadAndIdentify: "અપલોડ કરો અને ઓળખો", analyzeSkin: "ત્વચાનું વિશ્લેષણ કરો", result: "પરિણામ",
    backToHome: "હોમ પર પાછા જાઓ", loading: "લોડ થઈ રહ્યું છે...", serverError: "સર્વર ભૂલ આવી।", noFileSelected: "કોઈ ફાઇલ પસંદ નથી।",
    featuresTitle: "સારા સ્વાસ્થ્ય માટે તમને જોઈતું બધું",
    bodyMapFeature: "દૃષ્ટિ રૂપે લક્ષણો પસંદ કરવા શરીરના ભાગો પર ક્લિક કરો।",
    chatFeature: "સરળ ભાષામાં લક્ષણો જણાવો અને તાત્કાલિક આરોગ્ય માર્ગદર્શન મેળવો।",
    skinFeature: "AI વિશ્લેષણ માટે ફોલ્લી અથવા ત્વચાની સ્થિતિના ફોટા અપલોડ કરો।",
    labFeature: "રક્ત પરીક્ષણ અહેવાલ અપલોડ કરો અને સરળ સારાંશ મેળવો।",
    medicineFeature: "દવાના પેકેજિંગનો ફોટો લો અને ઉપયોગ વિશે જાણો।",
    hospitalFeature: "રેટિંગ અને દિશાઓ સાથે નજીકની હોસ્પિટલો શોધો।",
    tryItNow: "હવે અજમાવો", new: "નવું",
  },

  kn: {
    home: "ಮುಖಪುಟ", about: "ನಮ್ಮ ಬಗ್ಗೆ", bodyMap: "ದೇಹ ನಕ್ಷೆ",
    uploadLabReport: "ಲ್ಯಾಬ್ ವರದಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ", uploadMedicine: "ಔಷಧ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    skinDetector: "ಚರ್ಮ ಪರೀಕ್ಷೆ", contactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    findNearbyHospital: "ಹತ್ತಿರದ ಆಸ್ಪತ್ರೆ ಹುಡುಕಿ",
    homeTitle: "ಸಮಂಜಸ ಬೆಲೆಯಲ್ಲಿ ಅತ್ಯುತ್ತಮ ಆರೋಗ್ಯ ಸೇವೆಗಳನ್ನು ಪಡೆಯಿರಿ",
    homeSubtitle: "ಹೆಲ್ತ್‌ಕೇರ್ AI ಸಹಾಯಕ ನಿಮ್ಮ ದೈನಂದಿನ ಆರೋಗ್ಯ ಪ್ರಶ್ನೆಗಳಿಗೆ ಡಿಜಿಟಲ್ ಬಾಗಿಲು.",
    startHealthChat: "ಆರೋಗ್ಯ ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ", symptomChatGuidance: "ರೋಗಲಕ್ಷಣ ಚಾಟ್ ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    labMedicineUploads: "ಲ್ಯಾಬ್ ಮತ್ತು ಔಷಧ ಅಪ್‌ಲೋಡ್", hospitalsNearYou: "ನಿಮ್ಮ ಹತ್ತಿರದ ಆಸ್ಪತ್ರೆಗಳು",
    chatTitle: "ಹೆಲ್ತ್‌ಕೇರ್ AI ಸಹಾಯಕ",
    chatSubtitle: "ಇಲ್ಲಿ ರೋಗಲಕ್ಷಣಗಳ ಬಗ್ಗೆ ಚಾಟ್ ಮಾಡಿ. ಲ್ಯಾಬ್ ವರದಿಗಳಿಗೆ ಮೇಲಿನ ಮೆನು ಬಳಸಿ.",
    typeMessage: "ರೋಗಲಕ್ಷಣಗಳನ್ನು ವಿವರಿಸಿ ಅಥವಾ ಪ್ರಶ್ನೆ ಕೇಳಿ...", send: "ಕಳುಹಿಸಿ", speak: "ಮಾತನಾಡಿ", readAloud: "ಜೋರಾಗಿ ಓದಿ",
    bodyMapTitle: "ದೇಹ ನಕ್ಷೆ ರೋಗಲಕ್ಷಣ ಪರೀಕ್ಷಕ",
    bodyMapSubtitle: "ದೇಹದ ಭಾಗಗಳ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ, ರೋಗಲಕ್ಷಣಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ಮತ್ತು AI ಆರೋಗ್ಯ ಮಾಹಿತಿ ಪಡೆಯಿರಿ.",
    selectAffectedArea: "ಪ್ರಭಾವಿತ ಪ್ರದೇಶ ಆಯ್ಕೆ ಮಾಡಿ", clickBodyParts: "ಸಂಬಂಧಿತ ರೋಗಲಕ್ಷಣಗಳನ್ನು ನೋಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    generalSymptoms: "ಸಾಮಾನ್ಯ ರೋಗಲಕ್ಷಣಗಳು:", symptomsSelected: "ರೋಗಲಕ್ಷಣಗಳು ಆಯ್ಕೆಯಾದವು", symptomSelected: "ರೋಗಲಕ್ಷಣ ಆಯ್ಕೆಯಾಯಿತು",
    intensity: "ತೀವ್ರತೆ:", mild: "ಸೌಮ್ಯ", moderate: "ಮಧ್ಯಮ", severe: "ತೀವ್ರ",
    reset: "ರೀಸೆಟ್", analyzeSymptoms: "ರೋಗಲಕ್ಷಣಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ", analyzing: "ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
    analysisResult: "ವಿಶ್ಲೇಷಣೆ ಫಲಿತಾಂಶ", continueInChat: "ಚಾಟ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ",
    selectAtLeastOne: "ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ಒಂದು ರೋಗಲಕ್ಷಣ ಆಯ್ಕೆ ಮಾಡಿ",
    uploadMedicineTitle: "ಔಷಧದ ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    uploadMedicineSubtitle: "ಪ್ಯಾಕೇಜಿಂಗ್ ಅಥವಾ ಲೇಬಲ್‌ನ ಸ್ಪಷ್ಟ ಫೋಟೋ ತೆಗೆಯಿರಿ ಅಥವಾ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    uploadLabReportTitle: "ಲ್ಯಾಬ್ ವರದಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    uploadLabReportSubtitle: "ರಕ್ತ ಪರೀಕ್ಷೆ ವರದಿಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ಸುಲಭ ಸಾರಾಂಶ ಪಡೆಯಿರಿ.",
    skinDetectorTitle: "ಚರ್ಮ ರೋಗ ಡಿಟೆಕ್ಟರ್",
    skinDetectorSubtitle: "ಪ್ರಭಾವಿತ ಚರ್ಮದ ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು AI ಸಲಹೆಗಳನ್ನು ಪಡೆಯಿರಿ.",
    dropImageHere: "ಇಲ್ಲಿ ಚಿತ್ರ ಹಾಕಿ, ಅಥವಾ ಬ್ರೌಸ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    uploadAndIdentify: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ಗುರುತಿಸಿ", analyzeSkin: "ಚರ್ಮ ವಿಶ್ಲೇಷಿಸಿ", result: "ಫಲಿತಾಂಶ",
    backToHome: "ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ", loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...", serverError: "ಸರ್ವರ್ ದೋಷ ಸಂಭವಿಸಿದೆ.", noFileSelected: "ಯಾವುದೇ ಫೈಲ್ ಆಯ್ಕೆಯಾಗಿಲ್ಲ.",
    featuresTitle: "ಉತ್ತಮ ಆರೋಗ್ಯಕ್ಕಾಗಿ ನಿಮಗೆ ಬೇಕಾದ ಎಲ್ಲವೂ",
    bodyMapFeature: "ದೃಶ್ಯಾತ್ಮಕವಾಗಿ ರೋಗಲಕ್ಷಣಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ದೇಹದ ಭಾಗಗಳ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    chatFeature: "ಸರಳ ಭಾಷೆಯಲ್ಲಿ ರೋಗಲಕ್ಷಣಗಳನ್ನು ವಿವರಿಸಿ ಮತ್ತು ತಕ್ಷಣ ಆರೋಗ್ಯ ಮಾರ್ಗದರ್ಶನ ಪಡೆಯಿರಿ.",
    skinFeature: "AI ವಿಶ್ಲೇಷಣೆಗಾಗಿ ದದ್ದು ಅಥವಾ ಚರ್ಮದ ಸ್ಥಿತಿಯ ಫೋಟೋಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    labFeature: "ರಕ್ತ ಪರೀಕ್ಷೆ ವರದಿಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ಸುಲಭ ಸಾರಾಂಶ ಪಡೆಯಿರಿ.",
    medicineFeature: "ಔಷಧದ ಪ್ಯಾಕೇಜಿಂಗ್ ಫೋಟೋ ತೆಗೆಯಿರಿ ಮತ್ತು ಬಳಕೆಯ ಬಗ್ಗೆ ತಿಳಿಯಿರಿ.",
    hospitalFeature: "ರೇಟಿಂಗ್ ಮತ್ತು ದಿಕ್ಕುಗಳೊಂದಿಗೆ ಹತ್ತಿರದ ಆಸ್ಪತ್ರೆಗಳನ್ನು ಹುಡುಕಿ.",
    tryItNow: "ಈಗ ಪ್ರಯತ್ನಿಸಿ", new: "ಹೊಸ",
  },

  ml: {
    home: "ഹോം", about: "ഞങ്ങളെ കുറിച്ച്", bodyMap: "ബോഡി മാപ്പ്",
    uploadLabReport: "ലാബ് റിപ്പോർട്ട് അപ്‌ലോഡ് ചെയ്യുക", uploadMedicine: "മരുന്ന് അപ്‌ലോഡ് ചെയ്യുക",
    skinDetector: "ചർമ്മ പരിശോധന", contactUs: "ഞങ്ങളെ ബന്ധപ്പെടുക",
    findNearbyHospital: "അടുത്തുള്ള ആശുപത്രി കണ്ടെത്തുക",
    homeTitle: "ന്യായമായ വിലയ്ക്ക് മികച്ച ആരോഗ്യ സേവനങ്ങൾ നേടുക",
    homeSubtitle: "ഹെൽത്ത്‌കെയർ AI അസിസ്റ്റന്റ് നിങ്ങളുടെ ദൈനംദിന ആരോഗ്യ ചോദ്യങ്ങൾക്കുള്ള ഡിജിറ്റൽ വാതിലാണ്.",
    startHealthChat: "ആരോഗ്യ ചാറ്റ് ആരംഭിക്കുക", symptomChatGuidance: "രോഗലക്ഷണ ചാറ്റ് & മാർഗ്ഗനിർദ്ദേശം",
    labMedicineUploads: "ലാബ് & മരുന്ന് അപ്‌ലോഡുകൾ", hospitalsNearYou: "നിങ്ങൾക്ക് അടുത്തുള്ള ആശുപത്രികൾ",
    chatTitle: "ഹെൽത്ത്‌കെയർ AI അസിസ്റ്റന്റ്",
    chatSubtitle: "ഇവിടെ രോഗലക്ഷണങ്ങളെ കുറിച്ച് ചാറ്റ് ചെയ്യുക. ലാബ് റിപ്പോർട്ടുകൾക്ക് മുകളിലെ മെനു ഉപയോഗിക്കുക.",
    typeMessage: "രോഗലക്ഷണങ്ങൾ വിവരിക്കുക അല്ലെങ്കിൽ ചോദ്യം ചോദിക്കുക...", send: "അയക്കുക", speak: "സംസാരിക്കുക", readAloud: "ഉറക്കെ വായിക്കുക",
    bodyMapTitle: "ബോഡി മാപ്പ് രോഗലക്ഷണ പരിശോധക",
    bodyMapSubtitle: "ശരീര ഭാഗങ്ങളിൽ ക്ലിക്ക് ചെയ്ത് രോഗലക്ഷണങ്ങൾ തിരഞ്ഞെടുക്കുക, AI ആരോഗ്യ ഉൾക്കാഴ്ചകൾ നേടുക.",
    selectAffectedArea: "ബാധിത പ്രദേശം തിരഞ്ഞെടുക്കുക", clickBodyParts: "ബന്ധപ്പെട്ട രോഗലക്ഷണങ്ങൾ കാണാൻ ക്ലിക്ക് ചെയ്യുക",
    generalSymptoms: "പൊതു രോഗലക്ഷണങ്ങൾ:", symptomsSelected: "രോഗലക്ഷണങ്ങൾ തിരഞ്ഞെടുത്തു", symptomSelected: "രോഗലക്ഷണം തിരഞ്ഞെടുത്തു",
    intensity: "തീവ്രത:", mild: "ലഘു", moderate: "മിതമായ", severe: "കഠിനമായ",
    reset: "റീസെറ്റ്", analyzeSymptoms: "രോഗലക്ഷണങ്ങൾ വിശകലനം ചെയ്യുക", analyzing: "വിശകലനം ചെയ്യുന്നു...",
    analysisResult: "വിശകലന ഫലം", continueInChat: "ചാറ്റിൽ തുടരുക",
    selectAtLeastOne: "ദയവായി കുറഞ്ഞത് ഒരു രോഗലക്ഷണം തിരഞ്ഞെടുക്കുക",
    uploadMedicineTitle: "മരുന്നിന്റെ ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക",
    uploadMedicineSubtitle: "പാക്കേജിംഗ് അല്ലെങ്കിൽ ലേബലിന്റെ വ്യക്തമായ ഫോട്ടോ എടുക്കുക അല്ലെങ്കിൽ അപ്‌ലോഡ് ചെയ്യുക.",
    uploadLabReportTitle: "ലാബ് റിപ്പോർട്ട് അപ്‌ലോഡ് ചെയ്യുക",
    uploadLabReportSubtitle: "രക്ത പരിശോധന റിപ്പോർട്ടുകൾ അപ്‌ലോഡ് ചെയ്ത് എളുപ്പത്തിൽ മനസ്സിലാക്കാവുന്ന സംഗ്രഹം നേടുക.",
    skinDetectorTitle: "ചർമ്മ രോഗ ഡിറ്റക്ടർ",
    skinDetectorSubtitle: "ബാധിത ചർമ്മ ഭാഗത്തിന്റെ ഫോട്ടോ അപ്‌ലോഡ് ചെയ്ത് AI നിർദ്ദേശങ്ങൾ നേടുക.",
    dropImageHere: "ഇവിടെ ചിത്രം ഇടുക, അല്ലെങ്കിൽ ബ്രൗസ് ചെയ്യാൻ ക്ലിക്ക് ചെയ്യുക",
    uploadAndIdentify: "അപ്‌ലോഡ് ചെയ്ത് തിരിച്ചറിയുക", analyzeSkin: "ചർമ്മം വിശകലനം ചെയ്യുക", result: "ഫലം",
    backToHome: "ഹോമിലേക്ക് മടങ്ങുക", loading: "ലോഡ് ചെയ്യുന്നു...", serverError: "സർവർ പിശക് സംഭവിച്ചു.", noFileSelected: "ഒരു ഫയലും തിരഞ്ഞെടുത്തിട്ടില്ല.",
    featuresTitle: "മികച്ച ആരോഗ്യത്തിന് നിങ്ങൾക്ക് ആവശ്യമായ എല്ലാം",
    bodyMapFeature: "ദൃശ്യപരമായി രോഗലക്ഷണങ്ങൾ തിരഞ്ഞെടുക്കാൻ ശരീര ഭാഗങ്ങളിൽ ക്ലിക്ക് ചെയ്യുക.",
    chatFeature: "ലളിതമായ ഭാഷയിൽ രോഗലക്ഷണങ്ങൾ വിവരിക്കുക, ഉടനടി ആരോഗ്യ മാർഗ്ഗനിർദ്ദേശം നേടുക.",
    skinFeature: "AI വിശകലനത്തിനായി തടിപ്പ് അല്ലെങ്കിൽ ചർമ്മ അവസ്ഥകളുടെ ഫോട്ടോകൾ അപ്‌ലോഡ് ചെയ്യുക.",
    labFeature: "രക്ത പരിശോധന റിപ്പോർട്ടുകൾ അപ്‌ലോഡ് ചെയ്ത് എളുപ്പത്തിൽ മനസ്സിലാക്കാവുന്ന സംഗ്രഹം നേടുക.",
    medicineFeature: "മരുന്ന് പാക്കേജിംഗിന്റെ ഫോട്ടോ എടുക്കുക, ഉപയോഗങ്ങളെ കുറിച്ച് അറിയുക.",
    hospitalFeature: "റേറ്റിംഗുകളും ദിശകളും സഹിതം അടുത്തുള്ള ആശുപത്രികൾ കണ്ടെത്തുക.",
    tryItNow: "ഇപ്പോൾ പരീക്ഷിക്കുക", new: "പുതിയ",
  },

  pa: {
    home: "ਹੋਮ", about: "ਸਾਡੇ ਬਾਰੇ", bodyMap: "ਬਾਡੀ ਮੈਪ",
    uploadLabReport: "ਲੈਬ ਰਿਪੋਰਟ ਅਪਲੋਡ ਕਰੋ", uploadMedicine: "ਦਵਾਈ ਅਪਲੋਡ ਕਰੋ",
    skinDetector: "ਚਮੜੀ ਜਾਂਚ", contactUs: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    findNearbyHospital: "ਨੇੜੇ ਦਾ ਹਸਪਤਾਲ ਲੱਭੋ",
    homeTitle: "ਵਾਜਬ ਕੀਮਤ ਤੇ ਵਧੀਆ ਸਿਹਤ ਸੇਵਾਵਾਂ ਪ੍ਰਾਪਤ ਕਰੋ",
    homeSubtitle: "ਹੈਲਥਕੇਅਰ AI ਸਹਾਇਕ ਤੁਹਾਡੇ ਰੋਜ਼ਾਨਾ ਸਿਹਤ ਸਵਾਲਾਂ ਲਈ ਡਿਜੀਟਲ ਦਰਵਾਜ਼ਾ ਹੈ।",
    startHealthChat: "ਸਿਹਤ ਚੈਟ ਸ਼ੁਰੂ ਕਰੋ", symptomChatGuidance: "ਲੱਛਣ ਚੈਟ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ",
    labMedicineUploads: "ਲੈਬ ਅਤੇ ਦਵਾਈ ਅਪਲੋਡ", hospitalsNearYou: "ਤੁਹਾਡੇ ਨੇੜੇ ਹਸਪਤਾਲ",
    chatTitle: "ਹੈਲਥਕੇਅਰ AI ਸਹਾਇਕ",
    chatSubtitle: "ਇੱਥੇ ਲੱਛਣਾਂ ਬਾਰੇ ਚੈਟ ਕਰੋ। ਲੈਬ ਰਿਪੋਰਟਾਂ ਲਈ ਉੱਪਰ ਮੀਨੂ ਵਰਤੋ।",
    typeMessage: "ਲੱਛਣ ਦੱਸੋ ਜਾਂ ਸਵਾਲ ਪੁੱਛੋ...", send: "ਭੇਜੋ", speak: "ਬੋਲੋ", readAloud: "ਉੱਚੀ ਆਵਾਜ਼ ਵਿੱਚ ਪੜ੍ਹੋ",
    bodyMapTitle: "ਬਾਡੀ ਮੈਪ ਲੱਛਣ ਜਾਂਚਕਰਤਾ",
    bodyMapSubtitle: "ਸਰੀਰ ਦੇ ਅੰਗਾਂ ਤੇ ਕਲਿੱਕ ਕਰੋ, ਲੱਛਣ ਚੁਣੋ ਅਤੇ AI ਸਿਹਤ ਜਾਣਕਾਰੀ ਪ੍ਰਾਪਤ ਕਰੋ।",
    selectAffectedArea: "ਪ੍ਰਭਾਵਿਤ ਖੇਤਰ ਚੁਣੋ", clickBodyParts: "ਸੰਬੰਧਿਤ ਲੱਛਣ ਦੇਖਣ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    generalSymptoms: "ਆਮ ਲੱਛਣ:", symptomsSelected: "ਲੱਛਣ ਚੁਣੇ ਗਏ", symptomSelected: "ਲੱਛਣ ਚੁਣਿਆ ਗਿਆ",
    intensity: "ਤੀਬਰਤਾ:", mild: "ਹਲਕਾ", moderate: "ਦਰਮਿਆਨਾ", severe: "ਗੰਭੀਰ",
    reset: "ਰੀਸੈੱਟ", analyzeSymptoms: "ਲੱਛਣਾਂ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰੋ", analyzing: "ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ...",
    analysisResult: "ਵਿਸ਼ਲੇਸ਼ਣ ਨਤੀਜਾ", continueInChat: "ਚੈਟ ਵਿੱਚ ਜਾਰੀ ਰੱਖੋ",
    selectAtLeastOne: "ਕਿਰਪਾ ਕਰਕੇ ਘੱਟੋ ਘੱਟ ਇੱਕ ਲੱਛਣ ਚੁਣੋ",
    uploadMedicineTitle: "ਦਵਾਈ ਦੀ ਫੋਟੋ ਅਪਲੋਡ ਕਰੋ",
    uploadMedicineSubtitle: "ਪੈਕੇਜਿੰਗ ਜਾਂ ਲੇਬਲ ਦੀ ਸਾਫ਼ ਫੋਟੋ ਲਓ ਜਾਂ ਅਪਲੋਡ ਕਰੋ।",
    uploadLabReportTitle: "ਲੈਬ ਰਿਪੋਰਟ ਅਪਲੋਡ ਕਰੋ",
    uploadLabReportSubtitle: "ਖੂਨ ਜਾਂਚ ਰਿਪੋਰਟਾਂ ਅਪਲੋਡ ਕਰੋ ਅਤੇ ਆਸਾਨ ਸਾਰਾਂਸ਼ ਪ੍ਰਾਪਤ ਕਰੋ।",
    skinDetectorTitle: "ਚਮੜੀ ਰੋਗ ਡਿਟੈਕਟਰ",
    skinDetectorSubtitle: "ਪ੍ਰਭਾਵਿਤ ਚਮੜੀ ਦੀ ਫੋਟੋ ਅਪਲੋਡ ਕਰੋ ਅਤੇ AI ਸੁਝਾਅ ਪ੍ਰਾਪਤ ਕਰੋ।",
    dropImageHere: "ਇੱਥੇ ਤਸਵੀਰ ਪਾਓ, ਜਾਂ ਬ੍ਰਾਊਜ਼ ਕਰਨ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    uploadAndIdentify: "ਅਪਲੋਡ ਕਰੋ ਅਤੇ ਪਛਾਣੋ", analyzeSkin: "ਚਮੜੀ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰੋ", result: "ਨਤੀਜਾ",
    backToHome: "ਹੋਮ ਤੇ ਵਾਪਸ ਜਾਓ", loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...", serverError: "ਸਰਵਰ ਗਲਤੀ ਆਈ।", noFileSelected: "ਕੋਈ ਫਾਈਲ ਨਹੀਂ ਚੁਣੀ।",
    featuresTitle: "ਬਿਹਤਰ ਸਿਹਤ ਲਈ ਤੁਹਾਨੂੰ ਲੋੜੀਂਦਾ ਸਭ ਕੁਝ",
    bodyMapFeature: "ਦ੍ਰਿਸ਼ਟੀਗਤ ਰੂਪ ਵਿੱਚ ਲੱਛਣ ਚੁਣਨ ਲਈ ਸਰੀਰ ਦੇ ਅੰਗਾਂ ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    chatFeature: "ਸਰਲ ਭਾਸ਼ਾ ਵਿੱਚ ਲੱਛਣ ਦੱਸੋ ਅਤੇ ਤੁਰੰਤ ਸਿਹਤ ਮਾਰਗਦਰਸ਼ਨ ਪ੍ਰਾਪਤ ਕਰੋ।",
    skinFeature: "AI ਵਿਸ਼ਲੇਸ਼ਣ ਲਈ ਧੱਫੜ ਜਾਂ ਚਮੜੀ ਦੀਆਂ ਸਥਿਤੀਆਂ ਦੀਆਂ ਫੋਟੋਆਂ ਅਪਲੋਡ ਕਰੋ।",
    labFeature: "ਖੂਨ ਜਾਂਚ ਰਿਪੋਰਟਾਂ ਅਪਲੋਡ ਕਰੋ ਅਤੇ ਆਸਾਨ ਸਾਰਾਂਸ਼ ਪ੍ਰਾਪਤ ਕਰੋ।",
    medicineFeature: "ਦਵਾਈ ਦੀ ਪੈਕੇਜਿੰਗ ਦੀ ਫੋਟੋ ਲਓ ਅਤੇ ਵਰਤੋਂ ਬਾਰੇ ਜਾਣੋ।",
    hospitalFeature: "ਰੇਟਿੰਗਾਂ ਅਤੇ ਦਿਸ਼ਾਵਾਂ ਨਾਲ ਨੇੜੇ ਦੇ ਹਸਪਤਾਲ ਲੱਭੋ।",
    tryItNow: "ਹੁਣੇ ਅਜ਼ਮਾਓ", new: "ਨਵਾਂ",
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("preferredLanguage") || "en";
  });

  useEffect(() => {
    localStorage.setItem("preferredLanguage", language);
  }, [language]);

  const t = (key) => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
